import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { cpfMask } from 'common/validators';
export function CpfMaskCustom(props) {
  const { inputRef, name, value, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      name={name}
      mask={cpfMask(value)}
      guide={false}
    />
  );
}

CpfMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
};
